// ********************************************************************************************************************
// 后台主页
// ********************************************************************************************************************
const Exam = () => import('views/exam/Exam')
const ExamDashboard = () => import('views/exam/ExamDashboard')
const ExamSubject = () => import('views/exam/ExamSubject')
const ExamQuestion = () => import('views/exam/ExamQuestion')
const ExamQuestionAdd = () => import('views/exam/ExamQuestionAdd')
const ExamPaperList = () => import('views/exam/ExamPaperList')
const ExamPaperAssembly = () => import('views/exam/ExamPaperAssembly')
const ExamEvalList = () => import('views/exam/ExamEvalList')
const ExamPaperResult = () => import('views/exam/ExamPaperResult')
const ExamScoreIndex = () => import('views/exam/ExamScoreIndex')
const ExamMarkIndex = () => import('views/exam/ExamMarkIndex')
const ExamPaperPreview = () => import('views/exam/ExamPaperPreview')
const ExamPaperMark = () => import('views/exam/ExamPaperMark')
const ExamPaper = () => import('views/exam/ExamPaper')

export default {
  path: '/exam',
  name: 'Exam',
  component: Exam,
  meta: { needAuth: true },
  children: [
    {
      path: '',
      name: 'ExamDashboard',
      component: ExamDashboard,
      meta: { needAuth: true }
    },
    {
      path: '/exam/score',
      name: 'ExamScoreIndex',
      component: ExamScoreIndex,
      meta: { needAuth: true }
    },
    {
      path: '/exam/mark',
      name: 'ExamMarkIndex',
      component: ExamMarkIndex,
      meta: { needAuth: true }
    },
    {
      path: '/exam/subject',
      name: 'ExamSubject',
      component: ExamSubject,
      meta: { needAuth: true }
    },
    {
      path: '/exam/question',
      name: 'ExamQuestion',
      component: ExamQuestion,
      meta: { needAuth: true }
    },
    {
      path: '/exam/question/add',
      name: 'ExamQuestionAdd',
      component: ExamQuestionAdd,
      meta: { needAuth: true }
    },
    {
      path: '/exam/paper',
      name: 'ExamPaperList',
      component: ExamPaperList,
      meta: { needAuth: true }
    },
    {
      path: '/exam/paper/add',
      name: 'ExamPaperAssembly',
      component: ExamPaperAssembly,
      meta: { needAuth: true }
    },
    {
      path: '/exam/eval',
      name: 'ExamEvalList',
      component: ExamEvalList,
      meta: { needAuth: true }
    },
    {
      path: '/exam/eval/result',
      name: 'ExamPaperResult',
      component: ExamPaperResult,
      meta: { needAuth: true }
    },
    {
      path: '/exam/statistics',
      name: 'ExamDashboard',
      component: ExamDashboard,
      meta: { needAuth: true }
    },
    {
      path: '/exam/paper/preview',
      name: 'ExamPaperPreview',
      component: ExamPaperPreview,
      meta: { needAuth: true }
    },
    {
      path: '/exam/paper/mark',
      name: 'ExamPaperMark',
      component: ExamPaperMark,
      meta: { needAuth: true }
    },
    {
      path: '/exam/papers',
      name: 'ExamPaper',
      component: ExamPaper,
      meta: { title: 'ExamPaper', needAuth: false }
    }
  ]
}
